import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { CreateDossierParticulier } from "src/app/particulier/core/model/particulier/create-dossier-particulier";
import { BpParticulierService } from "src/app/parametrage/core/service/bp-particulier.service";
import { BpEngagementService } from "src/app/parametrage/core/service/bp-engagement.service";
import { BpParticulier } from "src/app/parametrage/core/model/bp-particulier";
import { BpEngagement } from "src/app/parametrage/core/model/bp-engagement";
import { EmployeurService } from "src/app/parametrage/core/service/employeur.service";
import { Employeur } from "src/app/parametrage/core/model/employeur";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";
import { ProduitService } from "src/app/parametrage/core/service/produit.service";
import { Produit } from "src/app/parametrage/core/model/produit";
import { Assurance } from "src/app/parametrage/core/model/assurance";
import { AssuranceService } from "src/app/parametrage/core/service/assurance.service";
import { TauxFraisInput } from "src/app/particulier/core/model/rule/taux-frais-input";
import { TauxFraisOutput } from "src/app/particulier/core/model/rule/taux-frais-output";
import { AnalyseParticulierInput } from "src/app/particulier/core/model/rule/analyse-particulier-input";
import { AnalyseParticulierOutput } from "src/app/particulier/core/model/rule/analyse-particulier-output";
import { RuleParticulierService } from "src/app/particulier/core/service/rule-particulier.service";
import { ParticulierFaciliteItem } from "src/app/particulier/core/model/particulier/particulier-facilite-item";
import { ParticulierService } from "src/app/particulier/core/service/particulier.service";
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import {
  CustomAdapter,
  CustomDateParserFormatter,
} from "src/app/shared/adapters/datepicker-adapter";

@Component({
  selector: "app-bni-create-dossier-credit",
  templateUrl: "./bni-create-dossier-credit.component.html",
  styleUrls: ["./bni-create-dossier-credit.component.scss"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class BniCreateDossierCreditComponent implements OnInit {
  workflowCode: String;

  errorMessage: string;
  pressButton: Boolean = false;

  form: FormGroup;

  dossierCredit: CreateDossierParticulier = new CreateDossierParticulier();

  bpParticulier: BpParticulier;
  bpEngagement: BpEngagement;

  dateControl: FormControl;
  dateControlExpPiece: FormControl;
  dateControlNaissance: FormControl;

  employeurs: Employeur[];

  typeCredits: TypeCredit[];
  produits: Produit[];
  assurances: Assurance[];

  tauxFraisInput: TauxFraisInput = new TauxFraisInput();
  tauxFraisOutput: TauxFraisOutput;

  analyseParticulierInput: AnalyseParticulierInput = new AnalyseParticulierInput();
  analyseParticulierOutput: AnalyseParticulierOutput;

  totalRevenuMensuel: number = 0;
  totalEngagementMensuel: number = 0;
  disponibleMensuel: number = 0;
  quotite: number = 0;
  quotiteNormale: number = 0;
  avisAnalyseRisque: Boolean = false;
  avisSurDemande: Boolean = false;

  isCalculated: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _bpEngagementService: BpEngagementService,
    private _bpParticulierService: BpParticulierService,
    private _employeurService: EmployeurService,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private _assuranceService: AssuranceService,
    private _ruleParticulierService: RuleParticulierService,
    private _particulierService: ParticulierService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      //info client
      customerCode: [null, Validators.compose([Validators.required])],
      dateReceptionDossier: ["", [Validators.compose([Validators.required])]],
      matricule: [null, Validators.compose([Validators.required])],
      firstname: [null, Validators.compose([Validators.required])],
      lastname: [null, Validators.compose([Validators.required])],
      fonction: [null, Validators.compose([Validators.nullValidator])],
      email: [null, Validators.compose([Validators.nullValidator])],
      situationMatrimoniale: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      adressePostale: [null, Validators.compose([Validators.nullValidator])],
      adresseGeographique: [null, Validators.compose([Validators.required])],
      homePhone: [null, Validators.compose([Validators.nullValidator])],
      mobilePhone: [null, Validators.compose([Validators.required])],
      workPhone: [null, Validators.compose([Validators.nullValidator])],
      employeurName: [null, Validators.compose([Validators.nullValidator])],
      employeur: [null, Validators.compose([Validators.required])],
      employeurAdresse: [null, Validators.compose([Validators.nullValidator])],

      dateEmbauche: ["", Validators.compose([Validators.nullValidator])],
      ancienneteEmploi: [
        "",
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      profession: [null, Validators.compose([Validators.required])],
      fonctionDansEntreprise: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      salaireEmprunteur: [
        0,
        [
          Validators.compose([Validators.required]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      salaireConjoint: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantLoyer: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantAutreRevenu: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],

      //info crédit
      typeCredit: [null, Validators.compose([Validators.required])],
      produit: [null, Validators.compose([Validators.required])],
      assurance: [null, Validators.compose([Validators.nullValidator])],
      montant: [
        0,
        [
          Validators.compose([Validators.required]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(1),
        ],
      ],
      periodicite: ["MENSUEL", Validators.compose([Validators.required])],
      echeance: [
        0,
        [
          Validators.compose([Validators.required]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(1),
        ],
      ],
      echeanceMensuelleEnCours: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      taux: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      nombreEcheance: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      frais: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      objetDemande: [
        "",
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(21843),
        ],
      ],

      //analyse dossier
      avisAnalyseRisque: [null, Validators.compose([Validators.requiredTrue])],
      avisSurDemande: [null, Validators.compose([Validators.requiredTrue])],

      garantiesArrayForm: this.fb.array([]),
    });
  }

  garantiesData = [
    /*{ checked: true, require: true, displayName: 'ravi2', name: 'b', index: 1 },
    { checked: true, require: true, displayName: 'ravi3', name: 'c', index: 2 }*/
  ];
  get garantiesArrayForm(): FormArray {
    return this.form.get("garantiesArrayForm") as FormArray;
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.workflowCode = params["workflowCode"];
    });

    this.getAllEmployeur();
    this.getListTypeCredit();
  }

  searchAndRefresh(): void {
    this.getBpParticulierBycodeclient(this.form.value.customerCode);
    this.getBpEngagementBycodeclient(this.form.value.customerCode);
  }

  getAllEmployeur() {
    this._employeurService.getAllEmployeurs().subscribe(
      (data) => {
        this.employeurs = data.filter((x) => x.active == true);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListTypeCredit() {
    this._typeCreditService
      .getListTypeCreditByWorkflow(this.workflowCode)
      .subscribe(
        (data) => {
          this.typeCredits = data.sort((a, b) => (a.label > b.label ? 1 : -1));
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getListproduitByTypeCredit() {
    this.produits = null;
    this._produitService
      .getListproduitByTypeCredit(this.form.value.typeCredit.id)
      .subscribe(
        (data) => {
          this.produits = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getListAssuranceByAmount() {
    let amount = Number(this.form.value.montant);

    this.assurances = [];

    this._assuranceService
      .getAssurancesByAmount(this.form.value.typeCredit.code, amount)
      .subscribe(
        (data) => {
          this.assurances = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getTauxFrais() {
    this.isCalculated = false;

    this.tauxFraisInput.codeTypeCredit = this.form.value.typeCredit.code;
    this.tauxFraisInput.employeur = this.form.value.employeur.label;
    this.tauxFraisInput.montantDemande = this.form.value.montant;
    this.tauxFraisInput.echeanceMois = this.calculEcheanceAvecPeriodicite();
    this.tauxFraisInput.salaireEmprunteur = this.form.value.salaireEmprunteur;
    this.tauxFraisInput.montantLoyer = this.form.value.montantLoyer;

    this._ruleParticulierService.ruleTauxFrais(this.tauxFraisInput).subscribe(
      (data) => {
        this.tauxFraisOutput = data;
        this.form.controls["echeanceMensuelleEnCours"].setValue(
          this.tauxFraisOutput.echeanceMensuelleEnCours
        );
        this.form.controls["taux"].setValue(this.tauxFraisOutput.taux);
        this.form.controls["frais"].setValue(this.tauxFraisOutput.frais);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  calculEcheanceAvecPeriodicite(): number {
    let echeance = 0;

    if (this.form.value.periodicite == "MENSUEL") {
      echeance = Number(this.form.value.echeance) * 1;
    } else if (this.form.value.periodicite == "TRIMESTRIEL") {
      echeance = Number(this.form.value.echeance) * 3;
    } else if (this.form.value.periodicite == "SEMESTRIEL") {
      echeance = Number(this.form.value.echeance) * 4;
    } else if (this.form.value.periodicite == "ANNUEL") {
      echeance = Number(this.form.value.echeance) * 12;
    }

    return echeance;
  }

  analyser() {
    this.isCalculated = true;

    this.analyseParticulierInput.codeTypeCredit =
      this.form.value.typeCredit.code;
    this.analyseParticulierInput.employeur = this.form.value.employeur.label;
    this.analyseParticulierInput.salaireEmprunteur =
      this.form.value.salaireEmprunteur;
    this.analyseParticulierInput.montantAutreRevenu =
      this.form.value.montantAutreRevenu;
    this.analyseParticulierInput.salaireConjoint =
      this.form.value.salaireConjoint;
    this.analyseParticulierInput.montantLoyer = this.form.value.montantLoyer;
    this.analyseParticulierInput.montantDemande = this.form.value.montant;
    this.analyseParticulierInput.echeanceMensuelleEnCours =
      this.form.value.echeanceMensuelleEnCours;
    this.analyseParticulierInput.echeanceMaxEmployeurMois =
      this.form.value.employeur.echeance;
    this.analyseParticulierInput.echeanceMois =
      this.calculEcheanceAvecPeriodicite();

    this._ruleParticulierService
      .ruleAnalyseCreditParticulier(this.analyseParticulierInput)
      .subscribe(
        (data) => {
          this.analyseParticulierOutput = data;

          this.totalRevenuMensuel =
            this.analyseParticulierOutput.totalRevenuMensuel;
          this.totalEngagementMensuel =
            this.analyseParticulierOutput.totalEngagementMensuel;
          this.disponibleMensuel =
            this.analyseParticulierOutput.disponibleMensuel;
          this.quotite = this.analyseParticulierOutput.quotite;
          this.quotiteNormale = this.analyseParticulierOutput.quotiteNormale;
          this.avisAnalyseRisque =
            this.analyseParticulierOutput.avisAnalyseRisque;
          this.avisSurDemande = this.analyseParticulierOutput.avisSurDemande;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  //
  getBpParticulierBycodeclient(codeclient) {
    this.spinner.show();

    this._bpParticulierService
      .getBpParticulierBycodeclient(codeclient)
      .subscribe(
        (data) => {
          this.bpParticulier = data;

          if (this.bpParticulier != null) {
            this.dossierCredit.firstname = this.bpParticulier.prenom;
            this.dossierCredit.lastname = this.bpParticulier.nom;

            if (
              this.bpParticulier.bpProfession != undefined &&
              this.bpParticulier.bpProfession != null
            ) {
              this.dossierCredit.profession =
                this.bpParticulier.bpProfession.libelle;
            }

            this.dossierCredit.email = this.bpParticulier.email;
            this.dossierCredit.mobilePhone = this.bpParticulier.telephone;
            this.dossierCredit.adressePostale =
              this.bpParticulier.adressepostal;
            this.dossierCredit.adresseGeographique =
              this.bpParticulier.adressegeo;

            let date1 = this.bpParticulier.datembauche.split(" ")[0];
            let date2 = date1.split(".");
            let date3 = date2[1] + "/" + date2[0] + "/" + date2[2];
            let docDate = date3;
            this.dateControl = new FormControl(
              this.addMinutes(new Date(docDate), 121)
            );

            this.dossierCredit.situationMatrimoniale =
              this.bpParticulier.matrimoniale;
          } else {
            this.dossierCredit.firstname = null;
            this.dossierCredit.lastname = null;
            this.dossierCredit.fonction = null;
            this.dossierCredit.email = null;
            this.dossierCredit.mobilePhone = null;
            this.dossierCredit.adressePostale = null;
            this.dossierCredit.adresseGeographique = null;
            this.dossierCredit.dateEmbauche = null;
          }

          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  getBpEngagementBycodeclient(codeclient) {
    this.spinner.show();
    this._bpEngagementService.getBpEngagementBycodeclient(codeclient).subscribe(
      (data1) => {
        this.bpEngagement = data1;

        if (this.bpEngagement != null) {
          this.dossierCredit.totalEngagementActuel = this.bpEngagement.montant;
        } else {
          this.dossierCredit.totalEngagementActuel = 0;
        }

        this.spinner.hide();
      },
      (error1) => {
        console.log(error1);
        this.spinner.hide();
      }
    );
  }
  //

  create(): void {
    const creditItem = new ParticulierFaciliteItem();
    creditItem.produit = this.form.value.produit;
    creditItem.periodicite = this.form.value.periodicite;
    creditItem.echeance = this.form.value.echeance;
    creditItem.montant = this.form.value.montant;
    creditItem.taux = this.form.value.taux;
    creditItem.echeanceMensuelleEnCours =
      this.form.value.echeanceMensuelleEnCours;
    creditItem.frais = this.form.value.frais;
    creditItem.assurance = this.form.value.assurance;
    creditItem.objetDemande = this.form.value.objetDemande;

    this.dossierCredit.particulierFaciliteItem = creditItem;
    const garanties = this.form.get("garantiesArrayForm").value;
    this.dossierCredit.garanties = garanties;

    this.spinner.show();
    this.pressButton = true;
    this._particulierService
      .createDossier(this.dossierCredit)
      .pipe(
        first(),
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          this.errorMessage = error.error.message;
          this.pressButton = false;
        }
      );
  }

  addMinutes(date, minutes): Date {
    return new Date(date.getTime() + minutes * 60000);
  }
}
